<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>COMENTARIOS</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">

      <div class="pt-2 px-6">

        <!-- DATOS SHOW -->
        <div class="vx-row">
          <small>
            <div class="vx-col w-full">
              <p><span class="font-semibold">Nombre & Email: </span>{{this.full_name_client | capitalize}} ({{ this.email_client }})</p>
            </div>
          </small>
        </div>

        <!-- NUEVO COMENTARIO -->
        <!-- TIPO DE COMENTARIO -->
        <div class="vx-col w-full mb-2 mt-2">
          <v-select :closeOnSelect="true" placeholder="Seleccione tipo de comentario" v-model="id_uct" label="name_uct" :options="userCommentTypes" name="name_uct" :reduce="userCommentTypes => userCommentTypes.id_uct" v-validate="'required'" data-vv-validate-on="blur"></v-select>
          <span class="text-danger text-sm" v-show="errors.has('id_uct')">{{ errors.first('id_uct') }}</span>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mt-2">
            <!-- <vs-textarea v-model="comment_uc" counter="255" class="mb-0 md:mt-1" rows="1" placeholder="Escriba un comentario..."/> -->
            <vx-input-group class="mb-base">
              <vs-input v-model="new_comment_uc" placeholder="Escriba un comentario..."/>
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button color="primary" @click="submitData()" :disabled="!isFormValid">Ingresar</vs-button>
                </div>
              </template>
            </vx-input-group>
            <span class="text-danger text-sm" v-show="errors.has('comment_uc')">{{ errors.first('comment_uc') }}</span>
          </div>
        </div>

        <vs-divider> Últimos comentarios </vs-divider>

        <!-- CARD COMENTARIOS VIEJOS -->
        <div v-if="UserCommentsForAClient">
          <div class="vx-col w-full mb-base mt-4" v-for="(comment, index) in UserCommentsForAClient" :key="index">
            <vx-card :title="comment.full_name_employee" no-shadow card-border>
              <template slot="actions">
                  <feather-icon icon="ClockIcon" svgClasses="w-4 h-4 text-grey mr-2"></feather-icon>
                  <small>{{ elapsedTime(comment.updated_at_uc) }}</small>
              </template>
              <template slot="no-body">
                <div class="text-justify pt-4 px-4">
                  <label class="pl-3">Tipo comentario: {{ comment.name_uct }}</label>
                  <vs-textarea v-model="comment.comment_uc" counter="255" class="border-transparent" :class="{'border-grey-light' : editCell}" :disabled="!editCell"/>
                </div>
              </template>
              <div class="flex justify-between text-center mt-4" slot="no-body-bottom">
                  <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                    <vs-button class="w-full my-2" type="flat" icon-pack="feather" icon="icon-edit" @click.stop="openEdition()" v-if="!editCell">Habilitar edición</vs-button>
                    <vs-button class="w-full my-2" type="flat" icon-pack="feather" icon="icon-edit" @click.stop="editComment(comment)" v-else>Editar</vs-button>
                  </div>
                  <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
                    <vs-button class="w-full my-2" type="flat" icon-pack="feather" icon="icon-trash" @click.stop="OpenConfirmDeleteComment(comment.id_uc)">Eliminar</vs-button>
                  </div>
              </div>
            </vx-card>
          </div>
        </div>

        
      </div>
    </VuePerfectScrollbar>
  
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { full_name_client, id_client, email_client } = JSON.parse(JSON.stringify(this.data))
        this.id_client = id_client
        this.full_name_client = full_name_client
        this.email_client = email_client
        this.clearFields()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data () {
    return {
      full_name_client: null, 
      email_client: null,
      id_added_service: null,
      dataImgContrato: null,
      full_path_file: null,
      editCell: false,
      comment_uc: null,
      id_uct: null,
      new_comment_uc: null,

      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    UserCommentsForAClient () {
      const UserCommentsForAClient = this.$store.state.UserCommentsForAClient
      return UserCommentsForAClient.slice().reverse()
    },
    userCommentTypes () {
      return this.$store.state.userCommentTypes
    },
    isFormValid () {
      return !this.errors.any() && this.new_comment_uc && this.id_uct
    }
  },
  methods: {
    openEdition () {
      this.editCell = true
    },
    OpenConfirmDeleteComment (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar Borrado',
        text: '¿Está seguro que deseas borrar el comentario?',
        accept: this.deleteDataItemComment,
        parameters: [id], // <---------- Se debe pasar el parámetro como una propiedad, para evitar que se ejecute de inmediato.
        acceptText: 'Borrar',
        cancelText: 'Cancelar'
      })
    },
    deleteDataItemComment (parameters) { 
      this.$store.dispatch('removeItemUserComment', parameters)
        .then(() => {
          this.$vs.notify({
            title: 'Comentario Borrado',
            text: 'El comentario ha sido borrado',
            color: 'danger',
            iconPack: 'feather',
            icon:'icon-alert-circle'
          }) 
        })
        .then(() => { this.updateCardUserComments() })
        .catch(err => { 
          this.$vs.loading.close()
          // console.log(Object.getOwnPropertyNames(err))
          console.error(err)
          // console.log(err.response.data.errors)
          if (typeof err.response.data.error === 'string') {
            this.$vs.notify({
              title: 'Error',
              text: `${err.response.data.error}`,
              color: 'warning',
              iconPack: 'feather',
              icon:'icon-x-circle',
              time: 6000
            })
          } else {
            const array_errors = Object.entries(err.response.data.error)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          }
        })
    },
    editComment (data) {
      const obj = {
        id: data.id_uc,
        user_comment_type_id: data.id_uct,
        client_id: data.id_client,
        comment: data.comment_uc
      }
      this.$vs.loading()
      this.$store.dispatch('updateItemUserComment', obj)
        .then(() => { this.$emit('closeSidebarSuccess') })
        .then(() => { this.$vs.loading.close() })
        .then(() => {
          this.$vs.notify({
            title: 'Comentario actualizado',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check'
          }) 
        })
        .then(() => { this.initValues() })
        .catch(err => { 
          this.$vs.loading.close()
          // console.log(Object.getOwnPropertyNames(err))
          console.error(err)
          // console.log(err.response.data.errors)
          if (typeof err.response.data.errors === 'string') {
            this.$vs.notify({
              title: 'Error',
              text: `${err.response.data.error}`,
              color: 'warning',
              iconPack: 'feather',
              icon:'icon-x-circle',
              time: 6000
            })
          } else {
            const array_errors = Object.entries(err.response.data.errors)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          }
        })
      this.editCell = false
      
    },
    elapsedTime (startTime) {
      const x        = new Date(startTime)
      const now      = new Date()
      let timeDiff = now - x
      timeDiff    /= 1000
      const seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      const hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      const days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      const years   = timeDiff

      if (years > 0) {
        return `hace ${years + (years > 1 ? ' años ' : ' año ')}`
      } else if (days > 0) {
        return `hace ${days + (days > 1 ? ' días ' : ' día ')}`
      } else if (hours > 0) {
        return `hace ${hours + (hours > 1 ? ' horas ' : ' hora ')}`
      } else if (minutes > 0) {
        return `hace ${minutes + (minutes > 1 ? ' minutos ' : ' minuto ')}`
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' hace un seg' : 'justo ahora')
      }

      return 'justo ahora'
    },
    initValues () {
      if (this.data.id_client) return
      // this.dataImgContrato = null
      this.selectedFileContrato = null
    },
    clearFields () {
      this.new_comment_uc = null
      this.id_uct = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            user_comment_type_id: this.id_uct,
            client_id: this.data.id_client,
            comment: this.new_comment_uc
          }
          this.$vs.loading()
          this.$store.dispatch('addItemUserComment', obj)
            .then(() => { this.$emit('closeSidebarSuccess') })
            .then(() => { this.$vs.loading.close() })
            .then(() => {
              this.$vs.notify({
                title: 'Comentario creado',
                text: 'Un comentario ha sido creado',
                color: 'success',
                iconPack: 'feather',
                icon:'icon-check'
              }) 
            })
            .then(() => { this.initValues() })
            .catch(err => { 
              this.$vs.loading.close()
              // console.log(Object.getOwnPropertyNames(err))
              console.error(err)
              // console.log(err.response.data.errors)
              if (typeof err.response.data.error === 'string') {
                this.$vs.notify({
                  title: 'Error',
                  text: `${err.response.data.error}`,
                  color: 'warning',
                  iconPack: 'feather',
                  icon:'icon-x-circle',
                  time: 6000
                })
              } else {
                const array_errors = Object.entries(err.response.data.error)
                for (let i = 0; i < array_errors.length; i++) {
                  this.$vs.notify({
                    title: 'Error',
                    text: `${array_errors[i][1][0]}`,
                    iconPack: 'feather',
                    icon: 'icon-x-circle',
                    color: 'warning',
                    time: 6000
                  })
                }
              }
            })
          this.$emit('closeSidebar')
          this.clearFields() 
        }
      })
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  created () {
    // console.log(this.data)
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 50000;
  }

  ::v-deep .vs-sidebar {
    z-index: 50000;
    width: 600px;
    max-width: 100vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}

.demo-alignment {
  margin-top:-15px;
}
</style>
